// tanstack
import { createRouter } from '@tanstack/react-router';

// relative
import NotFoundComponent from './routes/-NotFoundComponent.jsx';
import { routeTree } from './routeTree.gen.ts';

export const router = createRouter({
  routeTree,
  scrollRestoration: true,
  defaultNotFoundComponent: NotFoundComponent,
});
